// Root path → /dashboard (the auth-guarded layout will bounce unauthed users
// to /sign-in). See ADMIN_UI §2.2.

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard' });
  },
});
